export default __webpack_public_path__ + "static/media/Component51–1.72b932c2.svg";